<template>
  <div
    class="modal fade"
    id="file_version_modal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div
        :class="`modal-content bg-${getColorMode.background} text-${getColorMode.text}`"
      >
        <div
          :class="`modal-header bg-${getColorMode.globalBackground} text-${getColorMode.text} border-0 border-radius-20 shadow-table`"
        >
          <h5 class="modal-title" id="exampleModalLabel">Versiones</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <table :class="`table table-${getColorMode.background}`">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Nombre</th>
                <th scope="col">Versión</th>
                <!-- <th scope="col">Comentarios</th> -->
                <th scope="col">Descargar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="version in versions" v-bind:key="version.id">
                <th scope="row">{{ version.id }}</th>
                <td>{{ version.name }}</td>
                <td>{{ version.version }}</td>
                <!-- <td><a class="btn btn-primary" :href="version.url" target="_blank">Comentarios</a></td> -->
                <td>
                  <a class="btn btn-primary" :href="version.url" target="_blank"
                    >Descargar</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Modal } from "bootstrap";
export default {
  name: "FileVersion",
  emits: ["closeModal"],
  props: {
    projectId: { type: Number, default: 0 },
    folderId: { type: Number, default: 0 },
    fileId: { type: Number, default: 0 },
    folderFileId: { type: Number, default: 0 },
  },
  data() {
    return {
      modal: null,
      versions: [],
    };
  },
  mounted() {
    this.axios
      .get(
        `projects/${this.projectId}/folders/${this.folderId}/files/${this.fileId}/versions`
      )
      .then((result) => {
        let app = this;
        this.modal = new Modal(
          document.getElementById("file_version_modal"),
          {}
        );
        this.modal.show();
        this.versions = result.data.body;
        document
          .getElementById("file_version_modal")
          .addEventListener("hide.bs.modal", function () {
            app.$emit("closeModal");
          });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
};
</script>
